import React from 'react'

export const BlankCell = () => <td></td>
